/* Package JSON Import will be here */
import React from "react";
import { Radio, Row, Col } from "antd";
import { getTranslate } from "react-localize-redux";
import { useSelector } from 'react-redux';
/* Package JSON Import will be here */

/* Project Import will be here */
import Constants from "utilities/appConstants";
/* Project Import will be here */

const SortingTemplate = (props) => {
    const { translate, appSettings } = useSelector((state) => ({
        translate: getTranslate(state.locale),
        appSettings: state.appSettings
    }));

    return (
        <React.Fragment>
            <Radio.Group onChange={props.onChangeSortType} value={props.selectedSortType} className="w-100">
                {appSettings.IsSequenceOrder &&
                    <Row className="p-3 text-left">
                        <Col xs={{ span: 10 }}
                            sm={{ span: 6 }}
                            md={{ span: 6 }}
                            lg={{ span: 16 }}
                            xl={{ span: 14 }}
                            className=" m-auto"
                        >
                            <Radio value={Constants.DEFAULT}>{translate("filter.sortingFilter.default")}</Radio>
                        </Col>
                    </Row>
                }
                <Row className="p-3 text-left ">
                    <Col  xs={{ span: 10 }}
                            sm={{ span: 6 }}
                            md={{ span: 6 }}
                            lg={{ span: 16 }}
                            xl={{ span: 14 }}
                            className=" m-auto">
                        <Radio value={Constants.NAME_ASC}>{translate("filter.sortingFilter.nameAscending")}</Radio>
                    </Col>
                </Row>
                <Row className="p-3 text-left ">
                    <Col  xs={{ span: 10 }}
                            sm={{ span: 6 }}
                            md={{ span: 6 }}
                            lg={{ span: 16 }}
                            xl={{ span: 14 }}
                            className=" m-auto">
                        <Radio value={Constants.NAME_DESC}>{translate("filter.sortingFilter.nameDescending")}</Radio>
                    </Col>
                </Row>

                {/* Only show the price sorting filter in product sorting filter, For Sales return this logic is not applicable */}
                {(props.pageType === Constants.PLACE_ORDER_ATTR || props.pageType === Constants.EXCHANGE_ORDER_ATTR) &&
                    <React.Fragment>
                        <Row className="p-3 text-left ">
                            <Col  xs={{ span: 10 }}
                            sm={{ span: 6 }}
                            md={{ span: 6 }}
                            lg={{ span: 16 }}
                            xl={{ span: 14 }}
                            className=" m-auto">
                                <Radio value={Constants.PRICE_ASC}>{translate("filter.sortingFilter.priceLowToHigh")}</Radio>
                            </Col>
                        </Row>
                        <Row className="p-3 text-left ">
                            <Col  xs={{ span: 10 }}
                            sm={{ span: 6 }}
                            md={{ span: 6 }}
                            lg={{ span: 16 }}
                            xl={{ span: 14 }}
                            className=" m-auto">
                                <Radio value={Constants.PRICE_DESC}>{translate("filter.sortingFilter.priceHighToLow")}</Radio>
                            </Col>
                        </Row>
                    </React.Fragment>
                }
            </Radio.Group>
        </React.Fragment >
    );
};

export default SortingTemplate;